var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({background: _vm.value ? '#00ca72' : '#e44258', color: 'white', letterSpacing: '2px', height: '28px', lineHeight: '28px', textAlign: 'center'})},[(_vm.value)?_c('span',{staticStyle:{"flex":"1"}},[_vm._v(_vm._s(_vm.$t('_.signed')))]):_c('span',{staticStyle:{"flex":"1"}},[_vm._v(_vm._s(_vm.$t('_.unsigned')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }